module.exports = __webpack_public_path__ + "0ccf0c7f0d2df9ccd33631ba7c46fb82.png";